var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Node from '@core/plugin/common/component/node.vue';
import { asQueryString } from '@core/helper/url';
var TCTabs = /** @class */ (function (_super) {
    __extends(TCTabs, _super);
    function TCTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTabId = null;
        return _this;
    }
    Object.defineProperty(TCTabs.prototype, "prefix", {
        get: function () { return this.id != null ? "".concat(this.id, "_") : ''; },
        enumerable: false,
        configurable: true
    });
    ;
    TCTabs.prototype.data = function () {
        return {
            activeTabId: this.default != null ? this.default : 1
        };
    };
    TCTabs.prototype.mounted = function () {
        this.queryName = "".concat(this.prefix, "tab");
        var tabId;
        var queryTabId = asQueryString(this.$route.query[this.queryName]);
        if (queryTabId != null) {
            tabId = queryTabId;
        }
        else if (this.default != null) {
            tabId = this.default;
        }
        else if (this.tabs.length > 0) {
            tabId = this.tabs[0].id;
        }
        else {
            tabId = null;
        }
        this.setActiveTabId(tabId);
    };
    TCTabs.prototype.setActiveTabId = function (tabId) {
        var _a;
        if (this.activeTabId != tabId) {
            this.activeTabId = tabId;
            if (this.updateRoute) {
                this.$router.push({
                    query: __assign(__assign({}, this.$route.query), (_a = {}, _a[this.queryName] = this.activeTabId, _a))
                });
            }
            window.postMessage({
                type: 'tc-tabs-toggle',
                tabId: tabId,
            }, window.location.href);
        }
    };
    TCTabs.prototype.onRouteChanged = function () {
        var tabId = asQueryString(this.$route.query[this.queryName]);
        if (tabId != null && tabId != this.activeTabId) {
            this.setActiveTabId(tabId);
        }
    };
    __decorate([
        Prop({ type: String })
    ], TCTabs.prototype, "id", void 0);
    __decorate([
        Prop({ type: Array })
    ], TCTabs.prototype, "tabs", void 0);
    __decorate([
        Prop({ type: String })
    ], TCTabs.prototype, "default", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], TCTabs.prototype, "updateRoute", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], TCTabs.prototype, "isViewContainer", void 0);
    __decorate([
        Watch('$route')
    ], TCTabs.prototype, "onRouteChanged", null);
    TCTabs = __decorate([
        Component({
            inheritAttrs: false,
            components: { Node: Node },
        })
    ], TCTabs);
    return TCTabs;
}(Vue));
export default TCTabs;
